class AnalyserNode extends Weaver.Node

  @className = 'Analyser'

  constructor: (id) ->
    super(id)

  create: (name = "New Analyser", fftSize = 256) ->
    type = await Weaver.Node.firstOrCreate('Analyser')
    @set('name', name)
    @set('fftSize', fftSize)
    @relation('type').add(type)
    @save()

export default AnalyserNode
